import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const isInVenueMode = createSelector(
    appSettingsState,
    appSettings => appSettings.locationMode === OLO.Enums.APP_LOCATION_MODE.VENUE
);
